import { api } from '@packages/backend/convex/_generated/api';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { useQuery } from 'convex-helpers/react';
import { startOfDay } from 'date-fns';
import { ErrorAlert } from '@/components/ErrorAlert';

const startOfToday: number = startOfDay(new Date()).getTime();

export const Route = createFileRoute('/r/$restaurantId')({
  beforeLoad: async ({ location, params }) => {
    const { restaurantId } = params;
    if (location.pathname === `/r/${restaurantId}`) {
      throw redirect({
        params: { restaurantId },
        to: '/r/$restaurantId/menu/menu-items',
      });
    }
  },
  component: Component,
});

function Component() {
  const { restaurantId } = Route.useParams();

  // Note: It's important to keep these queries here as it allows Convex provider to cache
  // the queries for nested child routes.
  const menuQuery = useQuery(api.menus.getByRestaurantId, { restaurantId });
  const restaurantQuery = useQuery(api.restaurants.getById, { restaurantId });
  const usersQuery = useQuery(api.restaurantUsers.listByRestaurantId, { restaurantId });

  const posConfigQuery = useQuery(api.posConfigs.getByRestaurantId, { restaurantId });

  if (restaurantQuery.isError) {
    return <ErrorAlert message={restaurantQuery.error.message} title="Error loading restaurant" />;
  }
  if (menuQuery.isError) {
    return <ErrorAlert message={menuQuery.error.message} title="Error loading menu" />;
  }
  if (usersQuery.isError) {
    return <ErrorAlert message={usersQuery.error.message} title="Error loading menu" />;
  }
  if (posConfigQuery.isError) {
    return <ErrorAlert message={posConfigQuery.error.message} title="Error loading pos config" />;
  }

  // `getById` returns `null` when no restaurant is found for given id.
  // Block the child routes so menus, items, etc. can't be created against a dangling restaurant id.
  if (restaurantQuery.data === null) {
    return (
      <ErrorAlert
        message="We couldn't find a restaurant for this link. Check the URL and try again."
        title="Restaurant not found"
      />
    );
  }

  return <Outlet />;
}

// const excludeSuperAdminOnlyLinks = (links: NavLink[]): NavLink[] => {
//   return links
//     .filter((link) => !link.isSuperAdminOnly)
//     .map((link) => ({
//       ...link,
//       children: excludeSuperAdminOnlyLinks(link.children ?? []),
//     }));
// };
